// extracted by mini-css-extract-plugin
export default {"viewText":"providerViewTextAndTextarea_viewText__WUVrF"};